export const NotificationSectionStyle = {
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    margin: '32px 0',

    '@media (max-width: 639.98px)': {
      gridTemplateColumns: '1fr',
    },
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    // marginBottom: '16px',
  },
  itemsBtnWrapper: {
    display: 'flex',
    flexDirection: 'column',
    // gap: '12px',
    marginBottom: '24px',
    alignItems: 'flex-start',
  },

  itemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '24px',
    alignItems: 'flex-start',
  },

  disableBtn: {
    svg: {
      path: {
        fill: 'var(--primary-200)',
      },
    },
  },

  titleWithTooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '16px',

  },
  tooltipIcon: {
    	display: 'flex',

		'& svg': {
			width: '18px',
			height: '18px',
			'& path': {fill: 'var(--neutral-300)'},
		},
  },
};
